<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <el-date-picker
      ref="picker"
      class="w-full"
      :model-value="resolvedValue"
      :type="timeable ? 'datetime' : 'date'"
      :format="displayFormat"
      :value-format="valueFormat"
      :disabled-date="isDateDisabled"
      :disabled="disabled"
      @update:model-value="inputHandler"
  />
</template>

<script>
export default {
  name: 'EvDatepicker',
  emits: ['input', 'update:modelValue', 'update:value'],
  props: {
    value: { default: undefined },
    modelValue: { default: undefined },
    // EvFormField uses type="datepicker" to select this wrapper. Declare
    // the prop so it does not fall through to Element Plus as an invalid
    // date-picker type.
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    timeable: {
      type: Boolean,
      default: false
    },
    startDate: Date,
    endDate: Date,
    disabled: Boolean
  },
  computed: {
    resolvedValue() {
      return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
    },
    displayFormat() {
      return this.format
        .replace(/yyyy/g, 'YYYY')
        .replace(/dd/g, 'DD');
    },
    valueFormat() {
      return this.timeable ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  },
  methods: {
    inputHandler(value) {
      this.$emit('update:modelValue', value);
      this.$emit('update:value', value);
      this.$emit('input', value);
    },
    isDateDisabled(date) {
      const timestamp = date.getTime();
      if (this.startDate && timestamp < new Date(this.startDate).setHours(0, 0, 0, 0)) {
        return true;
      }
      return Boolean(this.endDate && timestamp > new Date(this.endDate).setHours(23, 59, 59, 999));
    }
  }
};
</script>
